"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["primary", "className", "transparent", "label", "trackObject", "onClick"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Primary UI component for user interaction
 */
var Button = function Button(_ref) {
  var primary = _ref.primary,
    className = _ref.className,
    transparent = _ref.transparent,
    label = _ref.label,
    trackObject = _ref.trackObject,
    onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, _excluded);
  var mode = primary ? 'primary' : 'secondary';
  var trnsp = transparent ? 'transparent' : '';
  var trackFn = function trackFn() {};
  if (trackObject && (typeof window === "undefined" ? "undefined" : _typeof(window)) !== "undefined" && _typeof(window.analytics) !== "undefined" && _typeof(window.analytics.track) !== "undefined") {
    trackObject.name = trackObject.name || "Marketing CTA Clicked";
    var obj = _objectSpread({
      page_url: window.location.pathname,
      type: 'button'
    }, trackObject);
    obj.text = trackObject.text || label;
    trackFn = function trackFn() {
      window.analytics.track(trackObject.name, obj);
    };
  }
  var onClickNew = function onClickNew() {
    if (typeof onClick === 'function') {
      onClick.apply(this, arguments);
    }
    trackFn();
  };
  return /*#__PURE__*/_react["default"].createElement("button", _extends({
    type: "button",
    className: ['btn', className ? className.replace(/undefined/g, '') : "", trnsp, mode].join(' '),
    onClick: onClickNew
  }, props), label);
};
exports.Button = Button;
Button.propTypes = {
  /**
   * Is this the principal call to action on the page?
   */
  primary: _propTypes["default"].bool,
  /**
   * transparent?
   */
  transparent: _propTypes["default"].bool,
  /**
   * What background color to use
   */
  className: _propTypes["default"].string,
  /**
   * Button contents
   */
  label: _propTypes["default"].string.isRequired,
  /**
   * Segments trackObject object e.g. {destination: '/service, name: "Marketing CTA Clicked"}.
   */
  trackObject: _propTypes["default"].object,
  /**
   * Optional click handler
   */
  onClick: _propTypes["default"].func
};
Button.defaultProps = {
  primary: false
};